// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbsLarge":"breadcrumbs_breadcrumbsLarge__Qxnpc","list":"breadcrumbs_list__kLXAj","crumb":"breadcrumbs_crumb__HYVOt"};